module.exports = __webpack_public_path__ + "img/mailbox-letter-flower.9f4eb1b6.svg";